import { cB as r, cM as t, c as o, cE as a, cNotM as e } from "../../../_utils/cssr/index.js";
const n = r("tabs", `
 box-sizing: border-box;
 width: 100%;
 display: flex;
 flex-direction: column;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
`, [t("segment-type", [r("tabs-rail", [o("&.transition-disabled", [r("tabs-capsule", `
 transition: none;
 `)])])]), t("top", [r("tab-pane", `
 padding: var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left);
 `)]), t("left", [r("tab-pane", `
 padding: var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left) var(--n-pane-padding-top);
 `)]), t("left, right", `
 flex-direction: row;
 `, [r("tabs-bar", `
 width: 2px;
 right: 0;
 transition:
 top .2s var(--n-bezier),
 max-height .2s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), r("tabs-tab", `
 padding: var(--n-tab-padding-vertical); 
 `)]), t("right", `
 flex-direction: row-reverse;
 `, [r("tab-pane", `
 padding: var(--n-pane-padding-left) var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom);
 `), r("tabs-bar", `
 left: 0;
 `)]), t("bottom", `
 flex-direction: column-reverse;
 justify-content: flex-end;
 `, [r("tab-pane", `
 padding: var(--n-pane-padding-bottom) var(--n-pane-padding-right) var(--n-pane-padding-top) var(--n-pane-padding-left);
 `), r("tabs-bar", `
 top: 0;
 `)]), r("tabs-rail", `
 position: relative;
 padding: 3px;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 background-color: var(--n-color-segment);
 transition: background-color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [r("tabs-capsule", `
 border-radius: var(--n-tab-border-radius);
 position: absolute;
 pointer-events: none;
 background-color: var(--n-tab-color-segment);
 box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .08);
 transition: transform 0.3s var(--n-bezier);
 `), r("tabs-tab-wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [r("tabs-tab", `
 overflow: hidden;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [t("active", `
 font-weight: var(--n-font-weight-strong);
 color: var(--n-tab-text-color-active);
 `), o("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])])]), t("flex", [r("tabs-nav", `
 width: 100%;
 position: relative;
 `, [r("tabs-wrapper", `
 width: 100%;
 `, [r("tabs-tab", `
 margin-right: 0;
 `)])])]), r("tabs-nav", `
 box-sizing: border-box;
 line-height: 1.5;
 display: flex;
 transition: border-color .3s var(--n-bezier);
 `, [a("prefix, suffix", `
 display: flex;
 align-items: center;
 `), a("prefix", "padding-right: 16px;"), a("suffix", "padding-left: 16px;")]), t("top, bottom", [r("tabs-nav-scroll-wrapper", [o("&::before", `
 top: 0;
 bottom: 0;
 left: 0;
 width: 20px;
 `), o("&::after", `
 top: 0;
 bottom: 0;
 right: 0;
 width: 20px;
 `), t("shadow-start", [o("&::before", `
 box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, .12);
 `)]), t("shadow-end", [o("&::after", `
 box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, .12);
 `)])])]), t("left, right", [r("tabs-nav-scroll-content", `
 flex-direction: column;
 `), r("tabs-nav-scroll-wrapper", [o("&::before", `
 top: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), o("&::after", `
 bottom: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), t("shadow-start", [o("&::before", `
 box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, .12);
 `)]), t("shadow-end", [o("&::after", `
 box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, .12);
 `)])])]), r("tabs-nav-scroll-wrapper", `
 flex: 1;
 position: relative;
 overflow: hidden;
 `, [r("tabs-nav-y-scroll", `
 height: 100%;
 width: 100%;
 overflow-y: auto; 
 scrollbar-width: none;
 `, [o("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `)]), o("&::before, &::after", `
 transition: box-shadow .3s var(--n-bezier);
 pointer-events: none;
 content: "";
 position: absolute;
 z-index: 1;
 `)]), r("tabs-nav-scroll-content", `
 display: flex;
 position: relative;
 min-width: 100%;
 min-height: 100%;
 width: fit-content;
 box-sizing: border-box;
 `), r("tabs-wrapper", `
 display: inline-flex;
 flex-wrap: nowrap;
 position: relative;
 `), r("tabs-tab-wrapper", `
 display: flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 flex-grow: 0;
 `), r("tabs-tab", `
 cursor: pointer;
 white-space: nowrap;
 flex-wrap: nowrap;
 display: inline-flex;
 align-items: center;
 color: var(--n-tab-text-color);
 font-size: var(--n-tab-font-size);
 background-clip: padding-box;
 padding: var(--n-tab-padding);
 transition:
 box-shadow .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [t("disabled", {
  cursor: "not-allowed"
}), a("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), a("label", `
 display: flex;
 align-items: center;
 z-index: 1;
 `)]), r("tabs-bar", `
 position: absolute;
 bottom: 0;
 height: 2px;
 border-radius: 1px;
 background-color: var(--n-bar-color);
 transition:
 left .2s var(--n-bezier),
 max-width .2s var(--n-bezier),
 opacity .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `, [o("&.transition-disabled", `
 transition: none;
 `), t("disabled", `
 background-color: var(--n-tab-text-color-disabled)
 `)]), r("tabs-pane-wrapper", `
 position: relative;
 overflow: hidden;
 transition: max-height .2s var(--n-bezier);
 `), r("tab-pane", `
 color: var(--n-pane-text-color);
 width: 100%;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .2s var(--n-bezier);
 left: 0;
 right: 0;
 top: 0;
 `, [o("&.next-transition-leave-active, &.prev-transition-leave-active, &.next-transition-enter-active, &.prev-transition-enter-active", `
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .2s var(--n-bezier),
 opacity .2s var(--n-bezier);
 `), o("&.next-transition-leave-active, &.prev-transition-leave-active", `
 position: absolute;
 `), o("&.next-transition-enter-from, &.prev-transition-leave-to", `
 transform: translateX(32px);
 opacity: 0;
 `), o("&.next-transition-leave-to, &.prev-transition-enter-from", `
 transform: translateX(-32px);
 opacity: 0;
 `), o("&.next-transition-leave-from, &.next-transition-enter-to, &.prev-transition-leave-from, &.prev-transition-enter-to", `
 transform: translateX(0);
 opacity: 1;
 `)]), r("tabs-tab-pad", `
 box-sizing: border-box;
 width: var(--n-tab-gap);
 flex-grow: 0;
 flex-shrink: 0;
 `), t("line-type, bar-type", [r("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 box-sizing: border-box;
 vertical-align: bottom;
 `, [o("&:hover", {
  color: "var(--n-tab-text-color-hover)"
}), t("active", `
 color: var(--n-tab-text-color-active);
 font-weight: var(--n-tab-font-weight-active);
 `), t("disabled", {
  color: "var(--n-tab-text-color-disabled)"
})])]), r("tabs-nav", [t("line-type", [t("top", [a("prefix, suffix", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), r("tabs-nav-scroll-content", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), r("tabs-bar", `
 bottom: -1px;
 `)]), t("left", [a("prefix, suffix", `
 border-right: 1px solid var(--n-tab-border-color);
 `), r("tabs-nav-scroll-content", `
 border-right: 1px solid var(--n-tab-border-color);
 `), r("tabs-bar", `
 right: -1px;
 `)]), t("right", [a("prefix, suffix", `
 border-left: 1px solid var(--n-tab-border-color);
 `), r("tabs-nav-scroll-content", `
 border-left: 1px solid var(--n-tab-border-color);
 `), r("tabs-bar", `
 left: -1px;
 `)]), t("bottom", [a("prefix, suffix", `
 border-top: 1px solid var(--n-tab-border-color);
 `), r("tabs-nav-scroll-content", `
 border-top: 1px solid var(--n-tab-border-color);
 `), r("tabs-bar", `
 top: -1px;
 `)]), a("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 `), r("tabs-nav-scroll-content", `
 transition: border-color .3s var(--n-bezier);
 `), r("tabs-bar", `
 border-radius: 0;
 `)]), t("card-type", [a("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 `), r("tabs-pad", `
 flex-grow: 1;
 transition: border-color .3s var(--n-bezier);
 `), r("tabs-tab-pad", `
 transition: border-color .3s var(--n-bezier);
 `), r("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 border: 1px solid var(--n-tab-border-color);
 background-color: var(--n-tab-color);
 box-sizing: border-box;
 position: relative;
 vertical-align: bottom;
 display: flex;
 justify-content: space-between;
 font-size: var(--n-tab-font-size);
 color: var(--n-tab-text-color);
 `, [t("addable", `
 padding-left: 8px;
 padding-right: 8px;
 font-size: 16px;
 justify-content: center;
 `, [a("height-placeholder", `
 width: 0;
 font-size: var(--n-tab-font-size);
 `), e("disabled", [o("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])]), t("closable", "padding-right: 8px;"), t("active", `
 background-color: #0000;
 font-weight: var(--n-tab-font-weight-active);
 color: var(--n-tab-text-color-active);
 `), t("disabled", "color: var(--n-tab-text-color-disabled);")])]), t("left, right", `
 flex-direction: column; 
 `, [a("prefix, suffix", `
 padding: var(--n-tab-padding-vertical);
 `), r("tabs-wrapper", `
 flex-direction: column;
 `), r("tabs-tab-wrapper", `
 flex-direction: column;
 `, [r("tabs-tab-pad", `
 height: var(--n-tab-gap-vertical);
 width: 100%;
 `)])]), t("top", [t("card-type", [r("tabs-scroll-padding", "border-bottom: 1px solid var(--n-tab-border-color);"), a("prefix, suffix", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), r("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-top-right-radius: var(--n-tab-border-radius);
 `, [t("active", `
 border-bottom: 1px solid #0000;
 `)]), r("tabs-tab-pad", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), r("tabs-pad", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `)])]), t("left", [t("card-type", [r("tabs-scroll-padding", "border-right: 1px solid var(--n-tab-border-color);"), a("prefix, suffix", `
 border-right: 1px solid var(--n-tab-border-color);
 `), r("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-bottom-left-radius: var(--n-tab-border-radius);
 `, [t("active", `
 border-right: 1px solid #0000;
 `)]), r("tabs-tab-pad", `
 border-right: 1px solid var(--n-tab-border-color);
 `), r("tabs-pad", `
 border-right: 1px solid var(--n-tab-border-color);
 `)])]), t("right", [t("card-type", [r("tabs-scroll-padding", "border-left: 1px solid var(--n-tab-border-color);"), a("prefix, suffix", `
 border-left: 1px solid var(--n-tab-border-color);
 `), r("tabs-tab", `
 border-top-right-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [t("active", `
 border-left: 1px solid #0000;
 `)]), r("tabs-tab-pad", `
 border-left: 1px solid var(--n-tab-border-color);
 `), r("tabs-pad", `
 border-left: 1px solid var(--n-tab-border-color);
 `)])]), t("bottom", [t("card-type", [r("tabs-scroll-padding", "border-top: 1px solid var(--n-tab-border-color);"), a("prefix, suffix", `
 border-top: 1px solid var(--n-tab-border-color);
 `), r("tabs-tab", `
 border-bottom-left-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [t("active", `
 border-top: 1px solid #0000;
 `)]), r("tabs-tab-pad", `
 border-top: 1px solid var(--n-tab-border-color);
 `), r("tabs-pad", `
 border-top: 1px solid var(--n-tab-border-color);
 `)])])])]);
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tabs/src/styles/index.cssr.js
// module id = 1745
// module chunks = 67